import script from "./OrderItemInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderItemInfo.vue?vue&type=script&setup=true&lang=ts"

import "./OrderItemInfo.vue?vue&type=style&index=0&id=4ec5eb60&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ec5eb60"]])

export default __exports__